function BacklogPlaceholder() {
  return (
    <div className="container" style={{ marginTop: "5rem" }}>
      <div className="fw-bold">SPRT-1</div>
      <div><span className="fw-bold">Timeline</span>: Unknown</div>
      <div className="placeholder-glow">
        <div style={{height: "2rem"}} className="placeholder mb-2 col-12 bg-success"></div>
        <div style={{height: "2rem"}} className="placeholder mb-2 col-12 bg-danger"></div>
        <div style={{height: "2rem"}} className="placeholder mb-2 col-12 bg-primary"></div>
      </div>
      <br />
      <div className="fw-bold">SPRT-2</div>
      <div><span className="fw-bold">Timeline</span>: Unknown</div>
      <div className="placeholder-glow">
        <div style={{height: "2rem"}} className="placeholder mb-2 col-12 bg-success"></div>
        <div style={{height: "2rem"}} className="placeholder mb-2 col-12 bg-danger"></div>
        <div style={{height: "2rem"}} className="placeholder mb-2 col-12 bg-primary"></div>
      </div>
      <br />
      <div className="fw-bold">Backlog</div>
      <div className="placeholder-glow">
        <div style={{height: "2rem"}} className="placeholder mb-2 col-12 bg-success"></div>
        <div style={{height: "2rem"}} className="placeholder mb-2 col-12 bg-danger"></div>
        <div style={{height: "2rem"}} className="placeholder mb-2 col-12 bg-primary"></div>
      </div>
    </div>
  );
}

export default BacklogPlaceholder;
